import { Grid, TextField } from '@mui/material';
import Box from '@mui/material/Box';
import dayjs from 'dayjs';
import * as React from 'react';
import * as Redux from 'react-redux';
import * as CONST from '../../../../../constants/FieldsConst';
import { dateformat } from '../../../../../helpers';
import { useNotification } from '../../../../../helpers/Notification';
import { EstatusField, LoadingWidget } from '../../../../../widgets';
import { FechaField } from '../../../../accesos/components/FechaField';
import { ADMIN_CONST } from '../../../../auth/login/LoginReducer';
import BotonComponent from '../../../../dashboard/components/BotonNuevo';
import SelectFieldEntidadesComponent from '../../../../entidad/entidades/components/SelectFieldEntidades';
import SelectFieldUsuariosComponent from '../../../../usuario/usuarios/components/SelectFieldUsuarios';
import { saveSuscripcionesAction } from '../SuscripcionesAction';

const FormSuscripciones = ({ setOpenModalForm }) => {
  const dispatch = Redux.useDispatch();
  const { notify } = useNotification();

  const suscripcionesStore = Redux.useSelector((state) => state.suscripciones);
  const { loadingAll } = Redux.useSelector((state) => state.entidades);

  const activo = suscripcionesStore.activo;

  const initData = {
    desde: dateformat(null, {}),
    hasta: dateformat(dayjs().add(1, 'y'), {}),
    desc: '',
    idEntidad: '',
    idTitular: '',
    idEstatus: 1,
  };

  const [data, setData] = React.useState(initData);
  const [dataError, setDataRequired] = React.useState({
    desde: false,
    hasta: false,
    idEntidad: false,
    idTitular: false,
  });
  const [loadingSave, setLoadingSave] = React.useState(false);

  React.useEffect(() => {
    if (!activo) return;
    let values = {};
    Object.keys(data).map((key) => (values[key] = activo[key]));
    setTimeout(
      () =>
        setData({
          ...values,
          idEntidad: activo.entidad.id,
          idTitular: activo.titular.id,
          idEstatus: activo.estatus?.id ?? 1,
        }),
      300,
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activo]);

  const _handleSetDataField = (key, value) =>
    setData({ ...data, [key]: value });

  const _validDataForm = () => {
    let r = {};
    let va = [];
    Object.keys(dataError).map((key) => {
      const val = data[key];
      const valid = !val || val === '' || val === 0;
      r[key] = valid;
      return va.push(valid);
    });
    setDataRequired(r);
    return !va.includes(true);
  };

  const _handleSubmit = async () => {
    if (_validDataForm()) {
      setLoadingSave(true);
      let res = await saveSuscripcionesAction(
        { dispatch, notify },
        activo?.id,
        data,
        suscripcionesStore.params,
      );
      if (res) setOpenModalForm(false);
      setLoadingSave(false);
    }
  };

  return (
    <Box component="form">
      <Grid container spacing={2}>
        {loadingSave && (
          <Grid item xs={12} md={12}>
            <LoadingWidget isLoading={loadingSave} isActivo={activo} />
          </Grid>
        )}

        {!activo && (
          <Grid item xs={12} md={12}>
            <SelectFieldEntidadesComponent
              value={data.idEntidad}
              notSuscripcion
              required
              onChange={(entidad) =>
                _handleSetDataField(CONST.entidad.idName, entidad)
              }
            />
          </Grid>
        )}
        {!activo && !loadingAll && (
          <Grid item xs={12} md={12}>
            <SelectFieldUsuariosComponent
              value={data.titular}
              rol={ADMIN_CONST}
              required
              notEntidad
              isAdmin
              onChange={(titular) =>
                _handleSetDataField(CONST.titular.idName, titular)
              }
            />
          </Grid>
        )}
        <Grid item xs={12} md={6}>
          <FechaField
            views={['year', 'month', 'day']}
            openTo="year"
            botonCurrentDate={false}
            label={CONST.desde.label}
            value={data.desde}
            error={dataError.desde}
            onChange={(e) =>
              _handleSetDataField(CONST.desde.name, dateformat(e, {}))
            }
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <FechaField
            views={['year', 'month', 'day']}
            openTo="year"
            botonCurrentDate={false}
            label={CONST.hasta.label}
            value={data.hasta}
            error={dataError.hasta}
            onChange={(e) =>
              _handleSetDataField(CONST.hasta.name, dateformat(e, {}))
            }
          />
        </Grid>
        <Grid item xs={12} md={12}>
          <TextField
            fullWidth
            size="small"
            id={CONST.desc.name}
            label={CONST.desc.label}
            value={data.desc}
            multiline
            rows={4}
            onChange={(e) =>
              _handleSetDataField(CONST.desc.name, e.target.value)
            }
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <EstatusField
            value={data.idEstatus}
            onChange={(e) =>
              _handleSetDataField(CONST.estatus.idName, e.target.value)
            }
            isEstatus
            required
            error={dataError.estatus}
          />
        </Grid>
        <Grid item xs={12} md={12} align="center">
          <BotonComponent
            click={_handleSubmit}
            text="GUARDAR"
            disabled={loadingSave}
            green
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default FormSuscripciones;
